import React from 'react'
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  vagasAplicadas: {
    minHeight: 200,
    maxHeight: 200,
  },
});

export default function VagasAplicadas(props) {
  const classes = useStyles();

  return (
    <Card className={classes.vagasAplicadas}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          Vagas aplicadas em aberto
          </Typography>
        <Typography gutterBottom variant="h3" component="h1" align={'right'}>
          {props.detalhesVagasAplicadas}
        </Typography>
      </CardContent>
    </Card>
  );
}